import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ReportsTitleBarState } from "../types";

// Initial state
const initialState: ReportsTitleBarState = {
  companies: [],
  isLoading: true,
  error: "",
  isError: false,
};

// Async thunk for fetching companies
export const fetchCompanies = createAsyncThunk(
  "reportsTitleBar/fetchCompanies",
  async (_, { extra }: any) => {
    if (!extra?.apiClient?.getV1Company) {
      throw new Error("API client not configured for reports title bar slice");
    }
    const response = await extra.apiClient.getV1Company();
    return response;
  }
);

export const reportsTitleBarSlice = createSlice({
  name: "reportsTitleBar",
  initialState,
  reducers: {
    setCompanies: (state, action) => {
      state.companies = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.isError = !!action.payload;
    },
    resetReportsTitleBarState: (state) => {
      Object.assign(state, initialState);
    },
  },
  extraReducers: (builder) => {
    /*-------------------------------- fetch companies Pending State ---------------------------------*/
    builder.addCase(fetchCompanies.pending, (state) => {
      state.isLoading = true;
      state.error = "";
      state.companies = [];
      state.isError = false;
    });
    
    builder.addCase(fetchCompanies.fulfilled, (state, action) => {
      state.companies = action.payload?.data?.company || [];
      state.isLoading = false;
      state.isError = false;
      state.error = "";
    });
    
    builder.addCase(fetchCompanies.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message || "Failed to fetch companies";
      state.isError = true;
    });
  },
});

export const { 
  setCompanies, 
  setLoading, 
  setError, 
  resetReportsTitleBarState 
} = reportsTitleBarSlice.actions;

export default reportsTitleBarSlice.reducer;